module.exports = __webpack_public_path__ + "img/SES_180412185.e3a9e964.jpg";